function setCookie(name, value, days) {
	let expires = ""
	if (days) {
		const date = new Date()
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
		expires = "; expires=" + date.toUTCString()
	}
	document.cookie = name + "=" + (value || "") + expires + "; path=/"
}

function getCookie(name) {
	const nameEQ = name + "="
	const ca = document.cookie.split(';')
	for(let i = 0; i < ca.length; i++) {
		let c = ca[i]
		while (c.charAt(0) == ' ') c = c.substring(1, c.length)
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
	}
	return null
}

export const is_plan_on = () => {
	const plan_on = getCookie('plan_on')
	if (plan_on == 'true')
		return true
	else
		return process.env.REACT_APP_PLAN_ON == 'true'
}
export const set_plan_on = v => {
	setCookie('plan_on', v ? true : false, 365)
}

// ---------------------------------------------------------------------------
// V3 forecast canary toggle (dev/secret — not advertised in the UI)
//
// The 24h forecast card normally reads V2 (unsafe_forecast_v2). Appending the
// secret query param below to ANY app URL switches it to V3 (unsafe_forecast_v3)
// and remembers the choice in a long-lived cookie so it sticks across sessions:
//
//   turn V3 ON  ->  https://app.wand.com.au/?fc=v3-canary-9f2a
//   turn V3 OFF ->  https://app.wand.com.au/?fc=off   (any value != the secret)
//
// Change FORECAST_V3_SECRET below to your own token to keep it private. When V3
// is active a clear banner is printed to the browser console, and every
// next_24_hours request carries `version: V3` (visible in the Network tab).
// ---------------------------------------------------------------------------
const FORECAST_V3_PARAM = 'fc'                    // secret query-param key
const FORECAST_V3_SECRET = 'v3-canary-9f2a'       // <-- CHANGE ME: exact value that turns V3 on
const FORECAST_V3_COOKIE = 'forecast_v3_on'
const FORECAST_V3_COOKIE_DAYS = 3650              // ~10y; browsers cap real persistence at ~400 days, so we refresh it on every load

// Reads the secret URL param (if present) and persists the choice to a cookie.
// Returns the effective on/off boolean.
const resolve_forecast_v3 = () => {
	let on = getCookie(FORECAST_V3_COOKIE) == 'true'
	let override = null
	try {
		override = new URLSearchParams(window.location.search).get(FORECAST_V3_PARAM)
	} catch (e) {
		override = null
	}
	if (override != null) {
		on = override == FORECAST_V3_SECRET
		setCookie(FORECAST_V3_COOKIE, on ? 'true' : 'false', FORECAST_V3_COOKIE_DAYS) // explicit toggle persists
	} else if (on) {
		setCookie(FORECAST_V3_COOKIE, 'true', FORECAST_V3_COOKIE_DAYS) // refresh expiry so it stays sticky
	}
	return on
}

let _v3_banner_logged = false
export const is_forecast_v3_on = () => {
	const on = resolve_forecast_v3()
	if (on && !_v3_banner_logged) {
		_v3_banner_logged = true
		console.log('%c ⚡ 24H FORECAST = V3 (canary) ', 'color:#fff;background:#c026d3;padding:3px 8px;border-radius:4px;font-weight:bold;font-size:12px')
		console.log('[forecast] next_24_hours is requesting version: V3 (unsafe_forecast_v3). Turn it off with ?' + FORECAST_V3_PARAM + '=off')
	}
	return on
}